/* @ngInject */
export default function (toastr, AuthService, $state) {
	AuthService.logout()
	           .then(() => {
		           $state.go('auth.login');
		           toastr.success('You were logged out successfully.');
	           });
};


// WEBPACK FOOTER //
// ./src/js/endpoints/auth/logout/controller.js